import ICommand from '../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../FrontApplet/FrontApplet';
import {
	ManagementFactoryResetRequest,
	ManagementFactoryResetResult,
	ManagementGetBatteryStatusRequest,
	ManagementGetBatteryStatusResult,
	ManagementGetBrandRequest,
	ManagementGetBrandResult,
	ManagementGetCapabilitiesRequest,
	ManagementGetCapabilitiesResult,
	ManagementGetExtendedManagementUrlRequest,
	ManagementGetExtendedManagementUrlResult,
	ManagementGetModelRequest,
	ManagementGetModelResult,
	ManagementGetSerialNumberRequest,
	ManagementGetSerialNumberResult,
	ManagementGetTemperatureRequest,
	ManagementGetTemperatureResult,
	ManagementRequests,
	ManagementResetSettingsRequest,
	ManagementResetSettingsResult,
	ManagementSetExtendedManagementUrlRequest,
	ManagementSetExtendedManagementUrlResult,
	ManagementSupportsRequest,
	ManagementSupportsResult,
} from './managementCommands';

export function handleManagementRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementSupportsRequest:
				await dispatch<ManagementSupportsResult>({
					type: ManagementSupportsResult,
					supports: await frontApplet.management.supports(commandEvent.command.capability),
				});
				break;
			case ManagementGetModelRequest:
				await dispatch<ManagementGetModelResult>({
					type: ManagementGetModelResult,
					model: await frontApplet.management.getModel(),
				});
				break;
			case ManagementGetSerialNumberRequest:
				await dispatch<ManagementGetSerialNumberResult>({
					type: ManagementGetSerialNumberResult,
					serialNumber: await frontApplet.management.getSerialNumber(),
				});
				break;
			case ManagementGetTemperatureRequest:
				await dispatch<ManagementGetTemperatureResult>({
					type: ManagementGetTemperatureResult,
					temperature: await frontApplet.management.getTemperature(),
				});
				break;
			case ManagementGetBrandRequest:
				await dispatch<ManagementGetBrandResult>({
					type: ManagementGetBrandResult,
					brand: await frontApplet.management.getBrand(),
				});
				break;
			case ManagementGetBatteryStatusRequest:
				await dispatch<ManagementGetBatteryStatusResult>({
					type: ManagementGetBatteryStatusResult,
					status: await frontApplet.management.getBatteryStatus(),
				});
				break;
			case ManagementResetSettingsRequest:
				await frontApplet.management.resetSettings();
				await dispatch<ManagementResetSettingsResult>({
					type: ManagementResetSettingsResult,
					result: {},
				});
				break;
			case ManagementFactoryResetRequest:
				await frontApplet.management.factoryReset();
				await dispatch<ManagementFactoryResetResult>({
					type: ManagementFactoryResetResult,
					result: {},
				});
				break;
			case ManagementGetExtendedManagementUrlRequest:
				await dispatch<ManagementGetExtendedManagementUrlResult>({
					type: ManagementGetExtendedManagementUrlResult,
					result: await frontApplet.management.getExtendedManagementUrl(),
				});
				break;
			case ManagementSetExtendedManagementUrlRequest:
				await frontApplet.management.setExtendedManagementUrl(commandEvent.command.url);
				await dispatch<ManagementSetExtendedManagementUrlResult>({
					type: ManagementSetExtendedManagementUrlResult,
					result: {},
				});
				break;
			case ManagementGetCapabilitiesRequest:
				await dispatch<ManagementGetCapabilitiesResult>({
					type: ManagementGetCapabilitiesResult,
					result: await frontApplet.management.getCapabilities(),
				});
				break;
			default:
		}
	});
}
